module.exports = __webpack_public_path__ + "static/media/UNIVERSAL.663faf96.gif";